import type { ChiaveRequisito, Requisito, VerdettoRilascio } from "../../server/domain/deploy/requisiti.ts";

/**
 * Il verdetto blue/green letto come una procedura.
 *
 * Tre condizioni sono scelte da fare, in quest'ordine: la strategia, il proxy
 * che sposta il traffico, il dominio a cui spostarlo. Le altre riguardano il
 * compose e di solito sono già a posto: compaiono come passi solo quando non lo
 * sono, così chi legge vede soltanto ciò su cui deve agire.
 */
export const GUIDATI: readonly ChiaveRequisito[] = ["strategia", "proxy", "instradamento"];

export function percorsoBlueGreen(v: VerdettoRilascio): {
  passi: readonly Requisito[];
  compatibili: readonly Requisito[];
  corrente: ChiaveRequisito | null;
} {
  const guidati = GUIDATI.map((chiave) => v.requisiti.find((r) => r.chiave === chiave)!);
  const compose = v.requisiti.filter((r) => !GUIDATI.includes(r.chiave));
  const passi = [...guidati, ...compose.filter((r) => !r.soddisfatto)];
  return {
    passi,
    compatibili: compose.filter((r) => r.soddisfatto),
    corrente: v.pronto ? null : (passi.find((p) => !p.soddisfatto)?.chiave ?? null),
  };
}
